// import React from "react";
import AddNote, { AddNoteFieldProps } from "./AddNote";
import ChangePassword from "./ChangePassword";
import AddCustomField, { AddCustomFieldProps } from "./AddCustomField";
import AddSubscription from "./AddSubscription";
import ParentalConsent, { ParentalConsentProps } from "./ParentalConsent";
import AddLocation, { AddLocationProps } from "./AddLocation";
import AddUser from "./AddUser";
import AddStudent, { AddStudentProps } from "./AddStudent";
import { LaunchForOthers, LaunchForSelf, LaunchProps } from "./LaunchOptions";
import BulkLaunch, { BulkLaunchProps } from "./BulkLaunch";
import { SendToParentOptions, SendToParentProps } from "./SendToParentOptions";
import SelectLocation, { SelectLocationProps } from "./SelectLocation";
// import UserGuide from "./UserGuide";
import { MakeAReferral, MakeAReferralProps } from "./MakeAReferral";
import { ISlideInContent } from "ui"
import TestSlideIn from "./testSlideIn";
import { ChangePasswordProps } from "./ChangePassword";
import { AddSubscriptionProps } from "./AddSubscription";
import { GetTriageProps, GetTriage } from "./GetTriage";

// export interface ISlideInContent<T = any> {
//     id: string;
//     header: string;
//     content: (props: T) => React.ReactNode;
//     // content: React.ComponentType<any>;
// }

export const ADD_USER: ISlideInContent = {
    id: "ADD_USER",
    header: "Add User",
    content: (props) => <AddUser {...props} />,
};

export const CHANGE_PASSWORD: ISlideInContent<ChangePasswordProps> = {
    id: "CHANGE_PASSWORD",
    header: "Change Password",
    content: (props) => <ChangePassword {...props} />,
};

export const ADD_LOCATION: ISlideInContent<AddLocationProps> = {
    id: "ADD_LOCATION",
    header: "Add Location",
    content: (props) => <AddLocation {...props} />
}
export const ADD_NEW_CUSTOMFIELD: ISlideInContent<AddCustomFieldProps> = {
    id: "ADD_NEW_CUSTOMFIELD",
    header: "Add New Custom Field",
    content: (props) => <AddCustomField {...props} />
}
export const ADD_SUBSCRIPTION: ISlideInContent<AddSubscriptionProps> = {
    id: "ADD_SUBSCRIPTION",
    header: "Add Subscription",
    content: (props) => <AddSubscription {...props} />
}
export const ADD_NOTE: ISlideInContent<AddNoteFieldProps> = {
    id: "ADD_NOTE",
    header: "Add Note",
    content: (props) => <AddNote {...props} />,
};

export const ADD_STUDENT: ISlideInContent<AddStudentProps> = {
    id: "ADD_STUDENT",
    header: "Add New Child",
    content: (props) => <AddStudent {...props} />,
};

export const PARENTAL_CONSENT: ISlideInContent<ParentalConsentProps> = {
    id: "PARENTAL_CONSENT",
    header: "Parental Consent Needed",
    content: (props) => <ParentalConsent {...props} />

}
export const LAUNCH_FOR_SELF: ISlideInContent<LaunchProps> = {
    id: "LAUNCH_OPTIONS",
    header: "Launch Options",
    content: (props) => <LaunchForSelf {...props} />,
};

export const SEND_TO_PARENT_OPTIONS: ISlideInContent<SendToParentProps> = {
    id: "SEND_TO_PARENT_OPTIONS",
    header: "Information for Parents",
    content: (props) => <SendToParentOptions {...props} />,
};
export const MAKE_A_REFERRAL: ISlideInContent<MakeAReferralProps> = {
    id: "MAKE_A_REFERRAL",
    header: "Make a Referral",
    content: (props) => <MakeAReferral {...props} />,
}

export const SELECT_LOCATION: ISlideInContent<SelectLocationProps> = {
    id: "SELECT_LOCATION",
    header: "Change Location",
    content: (props) => <SelectLocation {...props} />
}

export const GET_TRIAGE: ISlideInContent<GetTriageProps> = {
    id: "GET_TRIAGE",
    header: "Get Triage Report",
    content: (props) => <GetTriage {...props} />
}
export const BULK_LAUNCH: ISlideInContent<BulkLaunchProps> = {
    id: "BULK_LAUNCH",
    header: "Bulk Launch",
    content: (props) => <BulkLaunch {...props} />
}


export const LAUNCH_FOR_OTHERS: ISlideInContent<LaunchProps> = {
    id: "LAUNCH_FOR_OTHERS",
    header: "Launch for Others",
    content: (props) => <LaunchForOthers {...props} />
}

// // export const contentTypes: ISlideInContent[] = [
// //     // ADD_USER,
// //     CHANGE_PASSWORD,
// //     // ADD_NOTE,
// //     // LAUNCH_OPTIONS,
// //     // ADD_NOTE,
// // ];
export type TestProps = {
    action: () => void
}
// export const TEST_SLIDE_IN: ISlideInContent<TestProps> = {
//     id: "TEST_SLIDE_IN",
//     header: "Test slide in",
//     content: (props: TestProps) => React.createElement(TestSlideIn, props),
// }
export const TEST_SLIDE_IN: ISlideInContent<TestProps> = {
    id: "TEST_SLIDE_IN",
    header: "Test slide in",
    content: (props) => <TestSlideIn {...props} />
}